/**
 * Normalizes a JSON Pointer path and splits it into parts with RFC 6901 escape sequences decoded.
 *
 * @param dataPath - The RFC 6901 JSON Pointer path (e.g., "/a/b/c" or "/items/0").
 * @returns An object containing the normalized path parts and the first part separated from the rest.
 */
export const parsePathParts = (dataPath: string): { firstPart: string; restParts: string[] } => {
  const normalizedPath = dataPath.startsWith("/") ? dataPath.slice(1) : dataPath;
  const pathParts = normalizedPath.split("/").map((part) =>
    // Decode RFC 6901 escape sequences: ~1 -> /, ~0 -> ~
    part.replace(/~1/g, "/").replace(/~0/g, "~"),
  );

  const [firstPart, ...restParts] = pathParts;
  return { firstPart, restParts };
};
